(ns storrito.connect3.submit-phone-panel
  (:require [storrito.ui.button :as button]
            [storrito.connect3.common :as common]
            [clojure.string :as str]
            ))

(defn normalize-phone
  "Strips spaces, dashes and parentheses so '+49 (170) 123-4567' validates."
  [phone]
  (str/replace (str phone) #"[\s\-()]" ""))

(defn get-phone-validation-error
  "Returns a validation error for the phone number, or nil when it is ok.
   An empty submission would burn a challenge iteration server-side
   (handleExceptions.php rethrows and re-enters the checkpoint loop), so
   it must be caught here."
  [phone]
  (let [normalized (normalize-phone phone)]
    (cond
      (str/blank? normalized)
      "Please enter a phone number"

      (not (re-matches #"\+?[0-9]{6,15}" normalized))
      "Please enter a valid phone number, e.g. +1 555 0123456")))

(defn panel
  "Instagram's submit-phone checkpoint: the login only continues after a
   phone number is submitted for verification. connect.php waits for a
   reply with the \"phone-number\" key (handleExceptions.php,
   SubmitPhoneException case)."
  [state]
  (let [phone (:phone-number state)
        validation-error (get-phone-validation-error phone)
        send-action [[:connect3/send! {:phone-number (normalize-phone phone)}]]]
    [:div.flex.items-center.justify-center
     [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-10.pb-10.max-w-xl.w-full.mx-auto.flex.flex-col.items-center
      (common/instagram-logo)
      [:div.text-center.mb-5
       [:h2.font-bold.text-xl.text-center
        "Instagram needs to verify a phone number"]]
      [:p.text-gray-700.mb-6.text-center.w-full
       "Instagram asks for a phone number before this login can continue.
        Enter the phone number of this Instagram account, including the
        country code — Instagram will send a verification code to it."]
      [:div.flex.flex-col.justify-center.items-center.w-full
       ;; Wrapper div for password-manager compatibility, see comment in
       ;; `storrito.connect3.login-panel/panel`.
       [:div.w-full
        [:input#phone-number.w-full.px-5.py-3.placeholder-gray-500.border-gray-400.rounded-md.border-2.bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-blue-500.focus:border-blue-500.transition-all.duration-200.mb-2
         {:name "phone-number"
          :type "tel"
          :required true
          :autoComplete "tel"
          :placeholder "+1 555 0123456"
          :autoFocus true
          :on {:input [[:store/assoc-in [:connect3 :phone-number] :event/target.value]]
               :keyup (when-not validation-error
                        (into [[:js/on-enter]] send-action))}}]]
       (when (and (seq (str phone))
                  validation-error)
         [:p.text-sm.text-red-500.w-full.text-left.mb-2
          validation-error])
       (common/error-message state)
       (button/button-primary-lg
         {:class "w-full mt-4"
          :on {:click (when-not validation-error
                        send-action)}}
         "Send verification code")]]]))
